<template lang="html">
  <li class="article-list-item" @click="setCurrentArticle()">
    <a class="article-list-item-text article-list-items-font">{{ teaserText }}</a>

    <div v-show="isImageWide && hasImage" class="media-container-list wide">
      <img class="img-responsive-list wide" :src="imageSrc"/>
    </div>

    <div v-show="!isImageWide && hasImage" class="media-container-list tall">
      <img class="img-responsive-list tall" :src="imageSrc"/>
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['article', 'index'],
  data () {
    return { imageUid: String, imageSrc: '' }
  },
  mounted () {
    var listContainer = document.getElementById('article-list-container')
    listContainer.addEventListener('scroll', this.didScroll)

    if (this.currentArticle === undefined) {
      return
    }

    var scrollToArticle = this.currentArticle
    if (this.currentArticle.jumpOriginArticle !== null) {
      scrollToArticle = this.currentArticle.jumpOriginArticle
    }

    if (scrollToArticle === this.article) {
      let activeElem = document.getElementById('article-list-' + this.index)
      if (this.index > 5) {
        let scrollToIndex = this.index - 1
        let scrollToElem = document.getElementById('article-list-' + scrollToIndex)
        if (!this.isInViewport(scrollToElem) || !this.isInViewport(activeElem)) {
          scrollToElem.scrollIntoView()
        }
      }
      activeElem.classList.add('active')
    }

    this.applySettings(this.settings)
    this.setImage()
  },
  computed: {
    hasImage: function () {
      if (this.article !== undefined) {
        var imageUrl = null
        var locHasImg = false
        if (this.article.contextualImage.reference !== '') {
          this.imageUid = this.article.contextualImage.uid
          locHasImg = true
          imageUrl = this.getResourceUrl(this.article.contextualImage.reference, this.article.contextualImage.LastRev)
        } else {
          locHasImg = false
        }

        if (locHasImg && imageUrl !== null) {
          var children = this.article.children
          for (var j = 0; j < children.length; j++) {
            if ((children[j].kind.indexOf('Photo') !== -1 || children[j].kind.indexOf('Graphics') !== -1) && children[j].Uid === this.imageUid) {
              if (children[j].NoDisplay === 'true') {
                return false
              } else {
                return true
              }
            }
          }
        }
      }
    },
    isImageWide: function () {
      if (this.article.children.length > 0) {
        var children = this.article.children
        var imageHeight
        var imageWidth
        for (var j = 0; j < children.length; j++) {
          if (this.imageUid === children[j].Uid) {
            imageHeight = parseInt(children[j].ObjectHeight)
            imageWidth = parseInt(children[j].ObjectWidth)
            break
          }
        }

        if (imageHeight > imageWidth) {
          return false
        } else {
          return true
        }
      }
    },
    teaserText: function () {
      if (this.article.attributes.TeaserText !== undefined) {
        return this.article.attributes.TeaserText
      } else {
        return this.article.attributes.Headline
      }
    },
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      currentArticle: 'getCurrentArticle',
      settings: 'getSettings'
    })
  },
  watch: {
    settings: function (newValue) {
      this.applySettings(newValue)
    }
  },
  methods: {
    applySettings (settings) {
      if (settings !== undefined) {
        var itemTextElem = document.getElementsByClassName('article-list-item-text')
        for (var i = 0; i < itemTextElem.length; i++) {
          itemTextElem[i].style.color = settings.articleListItemsTextColor
        }
      }
    },
    setCurrentArticle () {
      var articleElements = document.getElementsByClassName('article-list-item')
      for (var i = 0; i < articleElements.length; i++) {
        articleElements[i].classList.remove('active')
      }
      var articleElement = document.getElementById('article-list-' + this.index)
      articleElement.classList.add('active')
      this.$cciEventTrackingPlugin.trackEvent('ContextArticleList', 'ActionArticleListCellClick', this.article)
      this.$store.commit('setCurrentArticle', this.article)
    },
    setImage () {
      if (this.article !== undefined) {
        var elem = document.getElementById('article-list-' + this.index)
        let isItInView = this.isInViewport(elem)
        if (!isItInView) {
          this.imageSrc = ''
          return
        }

        var imageUrl = null
        if (this.article.contextualImage.reference !== '') {
          this.imageUid = this.article.contextualImage.uid
          imageUrl = this.getResourceUrl(this.article.contextualImage.reference, this.article.contextualImage.LastRev)
        }

        if (imageUrl !== null) {
          var children = this.article.children
          for (var j = 0; j < children.length; j++) {
            if ((children[j].kind.indexOf('Photo') !== -1 || children[j].kind.indexOf('Graphics') !== -1) && children[j].Uid === this.imageUid) {
              if (children[j].NoDisplay === 'false') {
                if (imageUrl !== this.imageSrc) {
                  this.imageSrc = imageUrl
                  break
                }
              }
            }
          }
        }
      }
    },
    isInViewport (elem) {
      var bounding = elem.getBoundingClientRect()
      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    },
    didScroll () {
      this.setImage()
    }
  }
}
</script>

<style lang=scss>
@import 'helpers/_colors-and-mixins.scss';
@import 'base/_typography.scss';

.article-list-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  min-height: 71px;

  padding: 10px 10px;
  padding-left: 10px;
  margin-bottom: 0;
  border-bottom: thin solid rgba(128, 128, 128, 0.18);

  &:hover {
    background-color: rgba(128, 128, 128, 0.18);
  }

  p{
    color:$asbestos;
  }

  &.active{
    background-color: rgba(128, 128, 128, 0.50);
  }

  > a{
    color: $wet-asphalt;
    padding-right: 10px;
  }

  .media-container-list{
    min-width: 50px;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    float: right;
    overflow: hidden;
    &.tall {
      flex-direction: column;
    }
    .img-responsive-list{
      &.wide{
        height: 100%
      }
      &.tall{
        width: 100%
      }
    }
  }
}
</style>
